import React from 'react';
import { ProposalOutflowsSection } from 'Organisms/ProposalOutflowsSection';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDContentContainer } from '@facet-wealth/design';
import { MoneyflowsSectionTabWrapper } from './MoneyflowsSectionTabWrapper';

export const ProposalOutflowsSectionTabWrapper = ({ resource }) => {
  return (
    <FDContentContainer maxWidth={'lg'}>
      <MoneyflowsSectionTabWrapper>
        <ProposalOutflowsSection resource={resource} />
      </MoneyflowsSectionTabWrapper>
    </FDContentContainer>
  );
};

ProposalOutflowsSectionTabWrapper.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
